import _ from 'lodash';
import clsx from 'clsx';
import { Modal } from '@seeqdev/qomponents';
import type { SelectItemSearchWidgetProps } from '@/core/SelectItemSearchWidet.molecule';
import { SelectItemSearchWidget } from '@/core/SelectItemSearchWidet.molecule';
import type { SelectedSearchItem } from '@/search/search.types';

export interface SelectItemSearchModalProps extends SelectItemSearchWidgetProps {
  onClose: () => void;
  showHeaderCloseButton?: boolean;
  testId?: string;
  isMultiple?: boolean;
  header: {
    title: string;
    isEditable?: boolean;
    isTitleRequired?: boolean;
    titleIcon?: string;
    isInvalid?: boolean;
    placeholder?: string;
    onChange?: (e: any) => void;
  };
  /** HTML that should appear above search widget, but below title */
  body: React.JSX.Element | HTMLElement | null;
  footer?: React.JSX.Element;
  selectItems?: SelectedSearchItem[];
  showRecentlyAccessed?: boolean;
  onSubmit?: () => void;
}

export const SelectItemSearchModal: React.FunctionComponent<SelectItemSearchModalProps> = ({
  onClose,
  header,
  body,
  footer,
  showHeaderCloseButton = true,
  onSelect,
  iconPartialTooltipKey,
  selectItems,
  validateItem,
  scopeIds,
  excludeGloballyScoped = false,
  testId = 'selectAssetModal',
  modalId = testId,
  searchTypes,
  isMultiple,
  selectAllCallback = undefined,
  areAllSelected = () => false,
  showPinnedAssets = false,
  showOnlyScopedAssets = false,
  showOnlyConditions = false,
  showRecentlyAccessed = false,
  overrideWorkbookId = undefined,
  onSubmit,
  filterByWorkbook,
  itemTypeToShowInOverview,
  overviewLabel,
  showCreateNewItem = false,
  onCreateNewItem = _.noop,
  createNewItemMessage = '',
  createNewItemLabel = '',
  doNotDisableOnEdit = false,
}) => {
  return (
    <Modal
      open={true}
      onClose={onClose}
      size="sm"
      dialogClassName="scrollableSearchModal"
      testId={testId}
      title={header.title}
      isTitleEditable={header.isEditable}
      titleRequired={header.isTitleRequired}
      inputExtraClassNames={clsx('width-maximum', {
        'error-border': header.isInvalid,
      })}
      titlePlaceholder={header.placeholder}
      onTitleChanged={header.onChange}
      titleIcon={header.titleIcon}
      hideCloseIcon={!showHeaderCloseButton}
      modalFooter={footer}
      onSubmit={onSubmit}
      disableSubmitButton={!selectItems?.length}>
      <div>
        <>
          {body}
          <SelectItemSearchWidget
            onSelect={onSelect}
            iconPartialTooltipKey={iconPartialTooltipKey}
            selectedItems={selectItems}
            validateItem={validateItem}
            scopeIds={scopeIds}
            excludeGloballyScoped={excludeGloballyScoped}
            modalId={modalId}
            searchTypes={searchTypes}
            isMultiple={isMultiple}
            selectAllCallback={selectAllCallback}
            areAllSelected={areAllSelected}
            showPinnedAssets={showPinnedAssets}
            showOnlyScopedAssets={showOnlyScopedAssets}
            showOnlyConditions={showOnlyConditions}
            showRecentlyAccessed={showRecentlyAccessed}
            overrideWorkbookId={overrideWorkbookId}
            filterByWorkbook={filterByWorkbook}
            itemTypeToShowInOverview={itemTypeToShowInOverview}
            overviewLabel={overviewLabel}
            showCreateNewItem={showCreateNewItem}
            onCreateNewItem={onCreateNewItem}
            createNewItemMessage={createNewItemMessage}
            createNewItemLabel={createNewItemLabel}
            doNotDisableOnEdit={doNotDisableOnEdit}
          />
        </>
      </div>
    </Modal>
  );
};
